import * as React from "react";
import moment from "moment";
const acronyms = {
    Db: "DB",
    Dns: "DNS",
    Http: "HTTP",
    Https: "HTTPS",
    Ip: "IP",
    Sli: "SLI",
    Slo: "SLO",
    Url: "URL"
};
export const prettifyCheckName = (check) => {
    let splitName = check.split("_");
    for (let i = 0; i < splitName.length; i++) {
        splitName[i] = splitName[i].charAt(0).toUpperCase() + splitName[i].slice(1);
        if (acronyms.hasOwnProperty(splitName[i])) {
            splitName[i] = acronyms[splitName[i]];
        }
    }
    return splitName.join(" ");
};
export function formatDate(timestamp) {
    return (React.createElement("span", { title: moment(timestamp).format() }, moment(timestamp).fromNow()));
}
;
